//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.api

import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.ShopEvent

import com.tixforgigs.apax.infrastructure.*
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.request.forms.formData
import io.ktor.client.engine.HttpClientEngine
import kotlinx.serialization.json.Json
import io.ktor.http.ParametersBuilder
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

open class CommonEventsApi : ApiClient {

    constructor(
        baseUrl: String = ApiClient.BASE_URL,
        httpClientEngine: HttpClientEngine? = null,
        httpClientConfig: ((HttpClientConfig<*>) -> Unit)? = null,
        jsonSerializer: Json = ApiClient.JSON_DEFAULT
    ) : super(baseUrl = baseUrl, httpClientEngine = httpClientEngine, httpClientConfig = httpClientConfig, jsonBlock = jsonSerializer)

    constructor(
        baseUrl: String,
        httpClient: HttpClient
    ): super(baseUrl = baseUrl, httpClient = httpClient)

    /**
     * Get an event by its eventId - BETA (version from:4.6 to:latest)
     * ...
     * @param eventId 
     * @return ShopEvent
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun eventDetails(eventId: kotlin.Int): HttpResponse<ShopEvent> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/events/{eventId}".replace("{" + "eventId" + "}", "$eventId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Get pageable results of all available events. - EXPERIMENTAL (version from:4.6 to:latest)
     * For logged-in users: sorted with parameters like favorite genres, followed artists or attended events. The longest travel could be considered. For anonymous users: all known information about the user could be used to focus on possible best matches.
     * @param dbVersion Defines a db version to sync only a diff since this version. (optional, default to 0L)
     * @param details If details set to true, we send event data with products, resales,... if false, only data relevant for lists will be sent (optional)
     * @param page Zero-based page index (0..N) (optional, default to 0)
     * @param size The size of the page to be returned (optional, default to 24)
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. (optional)
     * @return kotlin.collections.List<ShopEvent>
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun eventsAll(dbVersion: kotlin.Long? = 0L, details: kotlin.Boolean? = null, page: kotlin.Int? = 0, size: kotlin.Int? = 24, sort: kotlin.collections.List<kotlin.String>? = null): HttpResponse<kotlin.collections.List<ShopEvent>> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        dbVersion?.apply { localVariableQuery["dbVersion"] = listOf("$dbVersion") }
        details?.apply { localVariableQuery["details"] = listOf("$details") }
        page?.apply { localVariableQuery["page"] = listOf("$page") }
        size?.apply { localVariableQuery["size"] = listOf("$size") }
        sort?.apply { localVariableQuery["sort"] = toMultiValue(this, "multi") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/events",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap<EventsAllResponse>().map { value }
    }

    @Serializable(EventsAllResponse.Companion::class)
    private class EventsAllResponse(val value: List<ShopEvent>) {
        companion object : KSerializer<EventsAllResponse> {
            private val serializer: KSerializer<List<ShopEvent>> = serializer<List<ShopEvent>>()
            override val descriptor = serializer.descriptor
            override fun serialize(encoder: Encoder, value: EventsAllResponse) = serializer.serialize(encoder, value.value)
            override fun deserialize(decoder: Decoder) = EventsAllResponse(serializer.deserialize(decoder))
        }
    }

    /**
     * Get pageable results of filtered events. - NOT_IMPLEMENTED (version from:4.6 to:latest)
     * ...
     * @param startDate 
     * @param endDate 
     * @param location 
     * @param category 
     * @param searchTerm 
     * @param page Zero-based page index (0..N) (optional, default to 0)
     * @param size The size of the page to be returned (optional, default to 12)
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. (optional)
     * @return kotlin.collections.List<ShopEvent>
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun eventsFiltered(startDate: kotlin.time.Instant, endDate: kotlin.time.Instant, location: kotlin.String, category: kotlin.String, searchTerm: kotlin.String, page: kotlin.Int? = 0, size: kotlin.Int? = 12, sort: kotlin.collections.List<kotlin.String>? = null): HttpResponse<kotlin.collections.List<ShopEvent>> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        page?.apply { localVariableQuery["page"] = listOf("$page") }
        size?.apply { localVariableQuery["size"] = listOf("$size") }
        sort?.apply { localVariableQuery["sort"] = toMultiValue(this, "multi") }
        startDate?.apply { localVariableQuery["startDate"] = listOf("$startDate") }
        endDate?.apply { localVariableQuery["endDate"] = listOf("$endDate") }
        location?.apply { localVariableQuery["location"] = listOf("$location") }
        category?.apply { localVariableQuery["category"] = listOf("$category") }
        searchTerm?.apply { localVariableQuery["searchTerm"] = listOf("$searchTerm") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/events/filtered",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap<EventsFilteredResponse>().map { value }
    }

    @Serializable(EventsFilteredResponse.Companion::class)
    private class EventsFilteredResponse(val value: List<ShopEvent>) {
        companion object : KSerializer<EventsFilteredResponse> {
            private val serializer: KSerializer<List<ShopEvent>> = serializer<List<ShopEvent>>()
            override val descriptor = serializer.descriptor
            override fun serialize(encoder: Encoder, value: EventsFilteredResponse) = serializer.serialize(encoder, value.value)
            override fun deserialize(decoder: Decoder) = EventsFilteredResponse(serializer.deserialize(decoder))
        }
    }

    /**
     * Get pageable results of nearby events. - NOT_IMPLEMENTED (version from:4.6 to:latest)
     * A list of nearby events. Only available for users sharing their location.
     * @param range The range in meters
     * @param page Zero-based page index (0..N) (optional, default to 0)
     * @param size The size of the page to be returned (optional, default to 8)
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. (optional)
     * @return kotlin.collections.List<ShopEvent>
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun eventsNearby(range: kotlin.Int, page: kotlin.Int? = 0, size: kotlin.Int? = 8, sort: kotlin.collections.List<kotlin.String>? = null): HttpResponse<kotlin.collections.List<ShopEvent>> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        page?.apply { localVariableQuery["page"] = listOf("$page") }
        size?.apply { localVariableQuery["size"] = listOf("$size") }
        sort?.apply { localVariableQuery["sort"] = toMultiValue(this, "multi") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/events/nearby/{range}".replace("{" + "range" + "}", "$range"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap<EventsNearbyResponse>().map { value }
    }

    @Serializable(EventsNearbyResponse.Companion::class)
    private class EventsNearbyResponse(val value: List<ShopEvent>) {
        companion object : KSerializer<EventsNearbyResponse> {
            private val serializer: KSerializer<List<ShopEvent>> = serializer<List<ShopEvent>>()
            override val descriptor = serializer.descriptor
            override fun serialize(encoder: Encoder, value: EventsNearbyResponse) = serializer.serialize(encoder, value.value)
            override fun deserialize(decoder: Decoder) = EventsNearbyResponse(serializer.deserialize(decoder))
        }
    }

    /**
     * Get template events. - BETA (version from:4.6 to:latest)
     * A list of events associated with the given templateId.
     * @param templateId 
     * @param details If details set to true, we send event data with products, resales,... if false, only data relevant for lists will be sent (optional)
     * @param page Zero-based page index (0..N) (optional, default to 0)
     * @param size The size of the page to be returned (optional, default to 24)
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. (optional)
     * @return kotlin.collections.List<ShopEvent>
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun eventsTemplate(templateId: kotlin.uuid.Uuid, details: kotlin.Boolean? = null, page: kotlin.Int? = 0, size: kotlin.Int? = 24, sort: kotlin.collections.List<kotlin.String>? = null): HttpResponse<kotlin.collections.List<ShopEvent>> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        details?.apply { localVariableQuery["details"] = listOf("$details") }
        page?.apply { localVariableQuery["page"] = listOf("$page") }
        size?.apply { localVariableQuery["size"] = listOf("$size") }
        sort?.apply { localVariableQuery["sort"] = toMultiValue(this, "multi") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/events/template/{templateId}".replace("{" + "templateId" + "}", "$templateId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap<EventsTemplateResponse>().map { value }
    }

    @Serializable(EventsTemplateResponse.Companion::class)
    private class EventsTemplateResponse(val value: List<ShopEvent>) {
        companion object : KSerializer<EventsTemplateResponse> {
            private val serializer: KSerializer<List<ShopEvent>> = serializer<List<ShopEvent>>()
            override val descriptor = serializer.descriptor
            override fun serialize(encoder: Encoder, value: EventsTemplateResponse) = serializer.serialize(encoder, value.value)
            override fun deserialize(decoder: Decoder) = EventsTemplateResponse(serializer.deserialize(decoder))
        }
    }

    /**
     * Get template contingents for an event. - BETA (version from:4.6 to:latest)
     * A list of contingents associated with the given templateId and eventId.
     * @param templateId 
     * @param eventId 
     * @return ShopEvent
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun eventsTemplateDetail(templateId: kotlin.uuid.Uuid, eventId: kotlin.Int): HttpResponse<ShopEvent> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/events/template/{templateId}/{eventId}".replace("{" + "templateId" + "}", "$templateId").replace("{" + "eventId" + "}", "$eventId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


}
